<!-- 食谱知识库组件 -->
<template>
  <div>
    <div class="form">
      <el-form ref="form" :inline="true" label-width="100px" :model="form" @submit.native.prevent>
        <el-row>
          <el-col :span="7">
            <el-form-item label="菜肴名称" prop="">
              <el-input v-model="form.foodName" clearable placeholder="请输入菜肴名称" />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="食材名称" prop="">
              <el-input v-model="form.material" clearable placeholder="请输入食材名称" />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="饮食类型" prop="">
              <el-select v-model="form.dietType" clearable placeholder="请选择">
                <template v-for="item in dietTypeList">
                  <el-option :label="item.dictValue" :value="item.dictKey" :key="item.dictKey" />
                </template>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="用餐时段" prop="">
              <el-select v-model="form.mealTime" clearable placeholder="请选择">
                <template v-for="item in mealTimeList">
                  <el-option :label="item.dictValue" :value="item.dictKey" :key="item.dictKey" />
                </template>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="中医证型" prop="">
              <el-select v-model="form.syndromeType" clearable placeholder="请选择">
                <template v-for="item in syndromeTypeList">
                  <el-option :label="item.dictValue" :value="item.dictKey" :key="item.dictKey" />
                </template>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="菜肴分类" prop="">
              <el-select v-model="form.foodType" clearable placeholder="请选择">
                <template v-for="item in foodTypeList">
                  <el-option :label="item.dictValue" :value="item.dictKey" :key="item.dictKey" />
                </template>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item>
              <el-button type="primary" @click="queryRecipe" native-type="submit">查询</el-button>
              <el-button type="default" native-type="submit" @click="reSet">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="list">
      <div>
        <el-button type="primary" size="small" @click="toggleDialog(true)">录入菜肴</el-button>
      </div>
      <el-table :data="table" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" style="width: 100%">
        <el-table-column prop="serialNumber" align="center" label="序号" />
        <el-table-column prop="dishName" align="center" label="菜肴组合名称" />
        <el-table-column prop="foodType" align="center" label="饮食类型">
          <template slot-scope="scope">
            <span>{{ calcTableFoodType(scope.row.dietType) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="ingredientName" align="center" label="食材" />
        <el-table-column prop="mealPeriod" align="center" label="用餐时段">
          <template slot-scope="scope">
            <span>{{ calcTableMealPeriod(scope.row.mealPeriod) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="tcmSyndromeType" align="center" label="中医证型">
          <template slot-scope="scope">
            <span>{{syndromeTypeList.find((item) => item.dictKey === scope.row.tcmSyndromeType).dictValue}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="isCalAnge" align="center" label="是否计入能量">
          <template slot-scope="scope">
            {{ CAL_ANGE_MAP[scope.row.isCountEnergy] || '' }}
          </template>
        </el-table-column>
        <el-table-column prop="dishCategory" align="center" label="菜肴分类">
          <template slot-scope="scope">
            <span>{{foodTypeList.find((item) => item.dictKey === scope.row.dishCategory).dictValue}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-link type="primary" @click="edit(scope.row)" :disabled="scope.row.auditStatus === '1'">编辑</el-link>
            <el-link v-if="scope.row.auditStatus === '1'" type="danger" :disabled="scope.row.auditStatus === '1'" style="margin-left: 10px;">删除</el-link>
            <el-popconfirm v-else title="确定删除该菜肴吗？" icon="el-icon-info" @confirm="deleteRow(scope.row.id)">
              <template #reference>
                <span class="reference-class" style="margin-left: 10px;">
                  <el-link type="danger">删除</el-link>
                </span>
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <AddDialog v-if="isShowDialog" :isOpen.sync="isShowDialog" :toggleOpen="toggleDialog" :dietTypeList="dietTypeList"
      :foodTypeList="foodTypeList" :mealTimeList="mealTimeList" :syndromeTypeList="syndromeTypeList"
      :submitCallBack="fetchTableList" :row="row" :closeCallBack="clearRow">
        <template v-slot:default="slotProps">
          <el-button :disabled="slotProps.isUpdate"  type="primary" @click="slotProps.submitForm('formRef')">提交审核</el-button>
          <el-button @click="slotProps.toggleOpen(false)">取 消</el-button>
        </template>
    </AddDialog>
  </div>
</template>

<script>
import AddDialog from "./addDialog.vue";
import { get, post } from "@/api/http";
import { CAL_ANGE_MAP } from './index.data';
import { submitHint } from '../common'
export default {
  name: "RecipeKnowledgeBase",
  components: { AddDialog },
  created() {
    this.fetchDietTypeList();
    this.fetchMealTimeList();
    this.fetchSyndromeTypeList();
    this.fetchFoodTypeList();
    this.fetchTableList();
  },
  mounted() {
	},
  data() {
    return {
      CAL_ANGE_MAP,
      isShowDialog: false,
      dietTypeList: [], // 饮食类型列表
      mealTimeList: [], // 用餐时段列表
      syndromeTypeList: [], // 中医证型列表
      foodTypeList: [], // 菜肴分类列表
      form: {
        // 查询条件提交对象
        foodName: "", // 菜肴名称
        material: "", // 食材名称
        dietType: "", // 饮食类型
        mealTime: "", // 用餐时段
        syndromeType: "", // 中医证型
        foodType: "", // 菜肴分类
      },
      tableLoad: false,
      table: [], // 表格数据
      currentPage: 1,
      pageSize: 10,
      total: 0,
      row: {}, // 编辑时传入的行数据信息
    };
  },
  methods: {
    // 切换对话框显示状态
    toggleDialog(isFlag = false) {
      this.isShowDialog = isFlag;
    },
    // 修改菜肴信息
    edit(row) {
      this.row = row;
      this.toggleDialog(true);
    },
    // 删除菜肴信息
    async deleteRow(id) {
      try {
        const params = {
          id,
          userId: this.$store.state.user_info.userId
        }
        const result = await post('dish/delete', params);
        const { code } = result;
        if (code === 'SUCCESS') {
          submitHint.call(this);
          this.fetchTableList();
        } else {
          this.$message.error('删除失败，请重试！');
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 重置查询条件
    reSet() {
      this.form = {
        foodName: "",
        material: "",
        dietType: "",
        mealTime: "",
        syndromeType: "",
        foodType: "",
      };
      this.fetchTableList();
    },
    // 清空修改久数据
    clearRow() {
      this.row = {};
    },
    // 查询饮食类型
    async fetchDietTypeList() {
      try {
        const result = await get("dictionary/type/diet_food_consistency");
        const { data = [] } = result || {};
        this.dietTypeList = data;
      } catch (error) {
        console.log(error);
      }
    },
    // 查询用餐时段
    async fetchMealTimeList() {
      try {
        const result = await get("dictionary/type/diet_meal_time");
        const { data = [] } = result || {};
        this.mealTimeList = data;
      } catch (error) {
        console.log(error);
      }
    },
    // 查询中医证型
    async fetchSyndromeTypeList() {
      try {
        const result = await get("dictionary/type/diet_syndrome_type");
        const { data = [] } = result || {};
        this.syndromeTypeList = data;
      } catch (error) {
        console.log(error);
      }
    },
    // 查询菜肴分类
    async fetchFoodTypeList() {
      try {
        const result = await get("dictionary/type/diet_food_type");
        const { data = [] } = result || {};
        this.foodTypeList = data;
      } catch (error) {
        console.log(error);
      }
    },
    // 查询菜肴
    queryRecipe() { 
      this.currentPage = 1;
      this.fetchTableList();
    },

    // 切换页码
    changePage(page) {
      this.currentPage = page;
      this.fetchTableList();
    },
    // 切换页面条数
    changeSize(size) {
      this.pageSize = size;
      this.fetchTableList();
    },
    //切换页面条数
    // 查询列表数据
    async fetchTableList() {
      try {
        const result = await get(
          `/dish/list?pageNum=${this.currentPage}&pageSize=${this.pageSize}&dishName=${this.form.foodName}&ingredientName=${this.form.material}&dietType=${this.form.dietType}&mealPeriod=${this.form.mealTime}&tcmSyndromeType=${this.form.syndromeType}&dishCategory=${this.form.foodType}`
        );
        const {
          data: { total = 0, list = [], pageNum = 1, pageSize = 10 } = {},
        } = result;
        this.total = total;
        this.currentPage = pageNum;
        this.pageSize = pageSize;
        this.table = list;
      } catch (error) {
        console.log(error);
      } 
    },
    // 计算表格用餐时段
    calcTableMealPeriod(mealPeriod) {
      const mealList = mealPeriod.split(',');
      const strList = mealList.map(item => this.mealTimeList.find(timeItem => timeItem.dictKey === item).dictValue);
      return strList.join(',');
    },
    // 计算饮食类型
    calcTableFoodType(foodType) {
      const foodList = foodType.split(',');
      const strList = foodList.map(item => this.dietTypeList.find(timeItem => timeItem.dictKey === item).dictValue);
      return strList.join(',');
    },
  },
};
</script>

<style scoped lang="scss"></style>
